import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import styled from 'styled-components';
import HeaderInfoM from '../lib/typography/HeaderInfoM';

function isValid(value) {
  return value.length >= 0 && value.length < 255;
}

const Wrapper = styled.div`
  display: flex;
  justifyContent: center;
  flex-direction: column;
  padding: 15px;
  border 1px solid #CCC;
  border-radius: 6px;
`;

const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const EditContentsTags = ({ product, type, setFieldValue }) => {
  const [contents, setContents] = useState(product[type] || []);

  useEffect(() => {
    setFieldValue(type, contents);
  }, [contents]);

  const handleChangeContentName = (e, index) => {
    const newContents = [...contents];
    if (newContents.length - 1 >= index) {
      const { value } = e.target;
      if (isValid(value)) {
        newContents[index] = value;
        setContents(newContents);
      }
    }
  };

  const handleAddContent = () => {
    const newContents = [...contents, ''];
    setContents(newContents);
  };

  const handleRemoveContent = (e, index) => {
    const newContents = [...contents];
    if (index > -1) {
      newContents.splice(index, 1);
    }
    setContents(newContents);
  };

  return (
    <Wrapper>
      <HeaderInfoM
        name={`${type === 'contents' ? 'CONTENTS / INGREDIENTS' : type.toUpperCase()}`}
        size="1rem"
        color="#000000"
        style={{ padding: '2px', letterSpacing: '-0.05em', marginBottom: '10px' }}
      />
      {contents.length !== 0 ? (
        contents.map((content, index) => {
          return (
            <div key={index} style={{ display: 'flex', marginBottom: '10px' }}>
              <TextField
                fullWidth
                size="small"
                id={`edit-${type}-${index}`}
                label={`${capitalize(type)} ${index + 1}`}
                variant="outlined"
                value={content}
                onChange={(e) => handleChangeContentName(e, index)}
              />
              <RemoveCircleIcon
                color="error"
                className="s-24-i ml-8"
                onClick={(e) => handleRemoveContent(e, index)}
                style={{ alignSelf: 'center', cursor: 'pointer' }}
              />
            </div>
          );
        })
      ) : (
        <div style={{ marginBottom: '10px' }}>{`Add ${type}`}</div>
      )}
      <Fab color="primary" aria-label="add" size="small" onClick={handleAddContent}>
        <AddIcon />
      </Fab>
    </Wrapper>
  );
};
